// Brochures.js
import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import "../styles/Brochures.css";
import "../styles/Herosstyle.css";
import bridgeHomeImage from "../assets/brochure.png";
import brochurePDF from "../assets/Brochure.pdf";

// Hero Section Component
const HeroSection = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className="hero-container">
      <div className="hero-background">
        <div className="hero-overlay" />
      </div>

      <div ref={ref} className={`hero-content ${inView ? "fade-in" : ""}`}>
        <h1 className="hero-title">
          <span>Building today</span>
          <br />
          for a sustainable tomorrow.
        </h1>
      </div>
    </section>
  );
};

// Card Holder Component
const CardHolder = ({ image }) => {
  const cardStyle = {
    border: "1px solid #ddd",
    borderRadius: "0px",
    overflow: "hidden",
    width: "300px",
    margin: "0 10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
  };

  const imageStyle = {
    width: "100%",
    height: "350px",
    transition: "transform 0.3s ease",
  };

  return (
    <div 
      style={cardStyle}
      className="card-hover"
    >
      <img src={image} alt="Brochure" style={imageStyle} />
    </div>
  );
};

// Brochure Section Component
const BrochureSection = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (pdfPath) => {
    try {
      setIsDownloading(true);
      
      // Create a link element
      const link = document.createElement('a');
      link.href = pdfPath;
      
      // Set the filename for the download
      const filename = pdfPath.split('/').pop();
      link.download = filename;
      
      // Append link to document, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Show success message
      const successMessage = document.createElement('div');
      successMessage.className = 'download-message success';
      successMessage.textContent = 'Download started successfully!';
      document.body.appendChild(successMessage);
      
      setTimeout(() => {
        document.body.removeChild(successMessage);
      }, 3000);
      
    } catch (error) {
      console.error('Download failed:', error);
      
      // Show error message
      const errorMessage = document.createElement('div');
      errorMessage.className = 'download-message error';
      errorMessage.textContent = 'Failed to download. Please try again.';
      document.body.appendChild(errorMessage);
      
      setTimeout(() => {
        document.body.removeChild(errorMessage);
      }, 3000);
    } finally {
      setIsDownloading(false);
    }
  };

  const cardContainerStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginTop: "30px",
    flexWrap: "wrap",
  };

  const downloadButtonStyle = {
    display: "block",
    width: "300px",
    padding: "10px 5px",
    textAlign: "center",
    backgroundColor: isDownloading ? "#999" : "#87212e",
    color: "white",
    fontWeight: "bold",
    fontSize: "16px",
    border: "none",
    borderRadius: "8px",
    cursor: isDownloading ? "not-allowed" : "pointer",
    marginTop: "20px",
    margin: "10px",
    transition: "background-color 0.3s ease, transform 0.2s ease",
  };

  const nameStyle = {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#333",
    marginTop: "10px",
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={cardContainerStyle}>
        <div>
          <CardHolder image={bridgeHomeImage} />
          <div style={nameStyle}>Brochure</div>
          <button
            style={downloadButtonStyle}
            onClick={() => handleDownload(brochurePDF)}
            disabled={isDownloading}
            className="download-button"
          >
            {isDownloading ? (
              <>
                <span className="loading-spinner"></span>
                Downloading...
              </>
            ) : (
              <>
                Download <i className="fas fa-download"></i>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

// Content Section Component
const ContentSection = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section
      ref={ref}
      className={`content-section ${inView ? "slide-up" : ""}`}
    >
      <div className="content-wrapper">
        <div className="content-category">BROCHURE</div>
        <h2 className="content-title">
Ray Infrastructures Private Limited        </h2>
        <BrochureSection />
      </div>
    </section>
  );
};

const Brochures = () => {
  return (

    
    <div>
      <HeroSection />
      <div className="dh">
        <ContentSection />
      </div>
    </div>
  );
};

export default Brochures;